import React from 'react';
import { Check } from 'lucide-react';
import { relocationPages } from '../../data/relocation';
import SEO from '../../components/SEO';

const RelocationChecklist = () => {
  const pageData = relocationPages.checklist;

  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <SEO
        title="Relocation Checklist"
        description="Your complete checklist for relocating to Mexico City - visa, housing, banking, healthcare, and more from The Mundalo."
        path="/relocation/checklist"
      />
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F9F6EF] border-b border-[#F4ECD8]">
        <div className="container-wide mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
            </a>
            <nav className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm font-medium text-[#1A5C6E] hover:text-[#2CA8A0] transition">Home</a>
              <a href="/relocation/cdmx" className="text-sm font-medium text-[#0A1F2E]">Relocation</a>
              <a href="/contact" className="btn-primary text-xs px-6 py-3">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="section">
        <div className="container-wide mx-auto">
          <a href="/relocation/cdmx" className="inline-block text-sm font-medium text-[#5A6B73] mb-6 hover:text-[#2CA8A0] transition">
            ← Back to Relocation Hub
          </a>
          <p className="label mb-4">Relocation Hub</p>
          <h1 className="heading-xl mb-6">{pageData.title}</h1>
          <p className="body-lg max-w-3xl">{pageData.description}</p>
        </div>
      </section>

      {/* Timeline Phases */}
      <section className="section-sm">
        <div className="container-narrow mx-auto">
          <div className="space-y-12">
            {pageData.phases.map((phase, idx) => (
              <div key={idx} className="bg-[#FFFFFF] border border-[#F4ECD8] p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-10 h-10 rounded-full bg-[#2CA8A0] text-[#F9F6EF] flex items-center justify-center font-semibold">
                    {idx + 1}
                  </div>
                  <h2 className="heading-md">{phase.title}</h2>
                </div>
                <ul className="space-y-3">
                  {phase.items.map((item, itemIdx) => (
                    <li key={itemIdx} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-[#2CA8A0] flex-shrink-0 mt-0.5" />
                      <span className="body-md">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-sm bg-[#FFFFFF] border-t border-[#F4ECD8]">
        <div className="container-narrow mx-auto text-center">
          <h2 className="heading-lg mb-4">Need Help Planning?</h2>
          <p className="body-md mb-8">
            Our relocation plans include personalized timelines and expert guidance.
          </p>
          <a href="/relocation/blueprint" className="btn-primary">View Relocation Plans</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="section-sm border-t border-[#F4ECD8]">
        <div className="container-wide mx-auto text-center">
          <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
          <p className="body-sm">© {new Date().getFullYear()} Mundalo. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RelocationChecklist;
